exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".full-page[data-v-07de77ae]:after,.full-page[data-v-07de77ae]:before{content:\"\";z-index:2}.full-page[data-v-07de77ae]:after,.full-page[data-v-07de77ae]:before,.is-img[data-v-07de77ae]{display:block;position:absolute;width:100%;height:100%;top:0;left:0}.is-img[data-v-07de77ae]{background-image:url(/img/full/ponte.jpg);background-size:cover;background-position:50%;z-index:1}.full-page[data-v-07de77ae]:after{background:#000;z-index:3;opacity:.6}", ""]);

// exports
